import React from 'react';
import Firebase from './Firebase';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react'
import Container from 'muicss/lib/react/container';
import AddToFavorites from './AddToFavorites';
import Button from 'muicss/lib/react/button';


// var lat;
// var lng;

var myDataGroup;

class BreweryDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      context: this,
      brewery: {},
      favorites: {}
  

    };
    // var brewery = this.props.params.breweryId;
    // const rootRef = Firebase.ref('colorado/' + brewery);

    // rootRef.on('value', snap => {
    //   myDataGroup = snap.val();
    //   localStorage.setItem('brewery', snap.val());
    //   //var myDataStore (myDataGroup);
    //   this.setState({
    //     brewery: snap.val()
        
    //   })
    // })
    
    // lat = this.state.brewery.lat;
    // lng = this.state.brewery.lng;

// console.log(myDataGroup);
// localStorage.setItem('brewery', JSON.stringify(myDataGroup));
//     var localBreweryStorageRef = localStorage.getItem(brewery);

//     if (localBreweryStorageRef) {
//       //update our component state and reflect what is in localStorage
//       this.setState({
//         brewery: JSON.parse(localBreweryStorageRef)
//       })
//     }
    

  }

  componentDidMount() {

  //   var addScript = document.createElement('script');
  // addScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBLwBQCWfVINpZPkXCdc3C3A-0Hgfns9RQ?sensor=false');
  // document.body.appendChild(addScript);

    var brewery = this.props.params.breweryId;
    const rootRef = Firebase.ref('colorado/' + brewery);
   // const latRef = Firebase.ref('colorado/' + brewery).child('lat');
   // console.log(latRef);

    rootRef.on('value', snap => {
      myDataGroup = snap.val();
      this.setState({
        brewery: snap.val()
      })
    })
    
    
    
    // lat = this.state.brewery.lat;
    // lng = this.state.brewery.lng;
   // console.log(myDataGroup);
    localStorage.setItem('brewery', JSON.stringify(myDataGroup));
    var localBreweryStorageRef = localStorage.getItem(brewery);

    if (localBreweryStorageRef) {
      //update our component state and reflect what is in localStorage
      this.setState({
        brewery: JSON.parse(localBreweryStorageRef)
      })
    }
    // this.setState({lat:this.state.brewery.lat});
    
  }


  getInitialCenter() {
    
  }

  render() {

    
   // console.log(this.state.brewery.lat);
    
 

       // <TheMap lat={this.state.brewery.lat} lng={this.state.brewery.lng} name={this.props.name} address={this.props.address} desc={this.props.desc}/>
// /  <Map google={window.google} lat={this.state.brewery.lat} lng={this.state.brewery.lng} name={this.props.name} address={this.props.address} desc={this.props.desc}/>

//  

     if (!this.state.brewery.lat) {
      return <div>Loading...</div>
    }

    var initialCenter= {
    // lat: Number(this.state.brewery.lat),
    // lng: Number(this.state.brewery.lng)
      lat: this.state.brewery.lat,
    lng: this.state.brewery.lng
    }

    

    return (
      <div>
       <Container fluid={true}>
        
       <h1>{this.state.brewery.name}</h1>    
       {this.state.brewery.address}
       <AddToFavorites className="brewery" brewery={this.state.brewery.name}/>
      
 <div className="map">
       <Map className="map" google={this.props.google} center={initialCenter} initialCenter={initialCenter} zoom={16}>
        <Marker />
        <Marker position={initialCenter} />
        </Map>
        
</div>

<Button variant="raised" color="danger" onClick={this.handleBackClick}>Back</Button>


</Container>
            
      </div>

    )

  }

  handleBackClick() {
    window.history.back();
}


}

// class TheMap extends React.Component {

  

//     componentDidMount() {
        
  
//         var breweryLatLng = new google.maps.LatLng(this.props.lat, this.props.lng);
       
//        console.log(this.props.lat);

//         var breweryContent = String(this.props.name) + "<br>" + this.props.address;

//         var mapProp = {
//             center: breweryLatLng,
//             zoom: 16,
//             mapTypeId: google.maps.MapTypeId.ROADMAP
//         };

//         this.map = new google.maps.Map(this.refs.map, mapProp);

//         var marker = new google.maps.Marker({
//             position: breweryLatLng,
//             map: this.map
//         });

//         var infowindow = new google.maps.InfoWindow({
//             content: breweryContent
//         });

//         marker.addListener('click', function () {
//             infowindow.open(this.map, marker);
//         });



//     }
//     render() {




//         const mapStyle = {
//             width: 300,
//             height: 300,
//             border: '1px solid black'
//         };

//         return (
//             <div ref="map" className="map-container">I should be a map!</div>
//         );
//     }
// }


//export default BreweryDetail;

export default GoogleApiWrapper({
  apiKey: 'AIzaSyBLwBQCWfVINpZPkXCdc3C3A-0Hgfns9RQ',
  libraries: ['places']
})(BreweryDetail)




/** WEBPACK FOOTER **
 ** ./src/BreweryDetail.js
 **/